// extracted by mini-css-extract-plugin
export default {"syllabus-wrapper":"Syllabus_syllabus-wrapper__kFkzk","icon":"Syllabus_icon__vXP9y"};